import { ConfirmModal } from '../../../shared/modal/ConfirmModal/ConfirmModal'

type ConfirmDeletePlanModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
  /** Event callback when modal is closed (Escape, Cancel, or X button) */
  onClose: () => void
}

const ConfirmDeletePlanModal = ({ isOpen, onConfirm, onClose }: ConfirmDeletePlanModalProps) => (
  <ConfirmModal
    confirmText="Delete Plan"
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Delete Plan"
  >
    Are you sure you want to delete this plan? This cannot be undone.
  </ConfirmModal>
)

export default ConfirmDeletePlanModal
